import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {HTTP_INTERCEPTORS, HttpRequest, provideHttpClient, withInterceptors, withInterceptorsFromDi} from '@angular/common/http';
import { MatNativeDateModule } from '@angular/material/core';
import { KeycloakService, KeycloakBearerInterceptor } from 'keycloak-angular';
import keycloakConfig from './auth/config/KeycloakConfig';

function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: keycloakConfig,
      enableBearerInterceptor: true,
      authorizationHeaderName: 'Authorization',
      bearerPrefix: 'Bearer',
      shouldAddToken: (request: HttpRequest<unknown>) => true,
      initOptions: {
        onLoad: 'login-required',
        //redirectUri: window.location.origin,
        checkLoginIframe: false
      }
    });
}

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes), provideAnimationsAsync(), provideHttpClient(withInterceptorsFromDi()), importProvidersFrom(MatNativeDateModule), KeycloakService,
    {
    provide: APP_INITIALIZER,
    useFactory: initializeKeycloak,
    multi: true,
    deps: [KeycloakService]
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: KeycloakBearerInterceptor,
    multi: true
  }]
};
